import React from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import POTemplateList from './POTemplate';
import OrderList from './PurchaseOrderList/OrderList';

function ComponentOrderList() {
  const params = useParams();
  const { templateType } = params;
  return templateType === 'po-template' ? <POTemplateList /> : <OrderList />;
}

export default ComponentOrderList;
